<!--
 * @Author: Junjie
 * @Date: 2024-08-12 13:56:18
 * @LastEditTime: 2024-08-12 14:49:46
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-wf-web/src/views/wf/WfConsumerCorpPermissionList.vue
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="企业名称">
              <a-input placeholder="请输入企业名称" v-debounce="searchQuery" v-model="queryParam.corpName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator">
      <a-button @click="handleSave" icon="save" type="primary">保存</a-button>
    </div>-->
    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="recharge(record)">充水量</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { httpAction, getAction } from '@/api/manage'
  import { difference } from 'lodash'

  export default {
    name: 'WfConsumerCorpPermissionList',
    mixins: [JeecgListMixin, mixinDevice],
    props: {
      deviceData: {
        type: Object,
        default: () => { }
      }
    },
    data () {
      return {
        ipagination: {
          current: 1,
          pageSize: 9999,
          total: 0,
          hideOnSinglePage: true
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '企业名称',
            align: "center",
            sorter: true,
            dataIndex: 'corpName'
          },
          {
            title: '联系人',
            align: "center",
            sorter: true,
            dataIndex: 'contact'
          },
          {
            title: '联系电话',
            align: "center",
            sorter: true,
            dataIndex: 'phone'
          },
          //   {
          //     title: '剩余可用量',
          //     align: "center",
          //     sorter: true,
          //     dataIndex: 'remainingVolume'
          //   },
          {
            title: '激活时间',
            align: "center",
            sorter: true,
            dataIndex: 'activatedTime',
            customRender: function (text) {
              return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
            }
          }
        ],
        url: {
          list: "/wf/wfConsumerCorp/list",
          getAuzCorps: "/wf/wfConsumerCorp/getAuzCorps",
          auzEdit: "/wf/wfConsumerCorp/auzEdit",
        },
        disableMixinCreated: true,
        dictOptions: {},
        superFieldList: [],
        auzCops: [],
      }
    },
    watch: {
      'dataSource': function () {
        this.selectedRowKeys = [...this.auzCops]
      },
      'auzCops': function () {
        this.selectedRowKeys = [...this.auzCops]
      },
    },
    created () {
      this.$set(this.dictOptions, 'disabled', [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }])
      this.getSuperFieldList();
      this.getAuzCorps();
    },
    methods: {
      getAuzCorps () {
        if (!this.deviceData.id) {
          return;
        }
        getAction(this.url.getAuzCorps, { devId: this.deviceData.id }).then(res => {
          if (res.success) {
            this.auzCops = res.result;

            this.queryParam.id = this.auzCops.join(',') + ',noid';
            this.loadData();
          } else {
            this.$message.error(res.message)
          }
        })
      },
      handleSave () {
        const that = this;
        // 找出新增的元素
        const added = difference(this.selectedRowKeys, this.auzCops).map(item => ({
          corpId: item,
          devId: that.deviceData.id
        }));
        // 找出删除的元素
        const removed = difference(this.auzCops, this.selectedRowKeys).map(item => ({
          corpId: item,
          devId: that.deviceData.id
        }));
        if (!added.length && !removed.length) {
          this.$message.warn('没有变化');
          return;
        }
        httpAction(this.url.auzEdit, {
          added, removed
        }, 'put').then(res => {
          if (res.success) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'corpName', text: '企业名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'contact', text: '联系人', dictCode: '' })
        fieldList.push({ type: 'string', value: 'phone', text: '联系电话', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'contractVolume', text: '合同用水量(吨)', dictCode: '' })
        fieldList.push({ type: 'int', value: 'contractCycle', text: '合同周期', dictCode: '' })
        fieldList.push({ type: 'string', value: 'contractCycleUnit', text: '合同周期单位', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'remainingVolume', text: '剩余可用量', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'overUsage', text: '允许超用量', dictCode: '' })
        fieldList.push({ type: 'date', value: 'joinTime', text: '加入时间' })
        fieldList.push({ type: 'switch', value: 'disabled', text: '禁止取水' })
        fieldList.push({ type: 'string', value: 'remark', text: '备注', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>